"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMiddleware = void 0;
function useMiddleware(addons, name) {
    if (!addons || !addons.length) {
        return function (initialValue) { return initialValue; };
    }
    return function (initialValue) {
        return addons
            .map(function (x) { return x[name]; })
            .filter(Boolean)
            .reduce(function (previous, middleware) { return middleware(previous); }, initialValue);
    };
}
exports.useMiddleware = useMiddleware;
//# sourceMappingURL=use-middleware.js.map